<template>
    <v-container>
        <p class="text-h4 ml-3 font-weight-bold black--text" style="margin-top: 4% !important">Checkout</p>
        <v-row class="mt-3 pl-2">
            <v-col cols="12" sm="7" v-if="order">
                <div class="text-h6 ml-1 mt-3 mb-5 font-weight-bold black--text">Provide Your Details</div>
                <customer-details-form v-model="order.customer" @addressesFound="$event => userAddresses = $event"></customer-details-form>
                <v-btn-toggle v-model="order.delivery.type" group rounded tile @change="updateDeliveryOption">
                    <div v-for="deliveryOption in $store.getters?.vendor?.delivery" :key="deliveryOption.code"
                        class="d-flex flex-wrap">
                        <v-btn small :value="deliveryOption" class="pa-1 py-8 mr-2 mb-2" outlined :style="themeInverted">
                            <v-icon class="mr-2" :size="isMobile ? 24 : 36" v-if="deliveryOption.code == PICKUP_FROM_SHOP">mdi-storefront</v-icon>
                            <v-icon class="mr-2" :size="isMobile ? 24 : 36" v-if="deliveryOption.code == HOME_DELIVERY">mdi-truck-delivery</v-icon>
                            <label>{{ deliveryOption.label }}</label>
                        </v-btn>
                    </div>
                </v-btn-toggle>
                <list-addresses v-model="order.delivery.pickupPoint" title="Available Pickup Points"
                    :addresses="pickupPoints" v-if="order.delivery.type.code == PICKUP_FROM_SHOP"></list-addresses>
                <div v-if="order.delivery.type.code == HOME_DELIVERY">
                    <list-addresses v-model="order.delivery.address" title="Select a Shipping address"
                        :addresses="userAddresses" :showAddNewBtn="true" @newAddress="$event => order.customer.address = $event"></list-addresses>
                </div>
                <v-divider v-if="isMobile"></v-divider>
                <div class="text-h6 ml-1 my-2 font-weight-bold black--text">Select Your Payment Method</div>
                <v-btn-toggle v-model="paymentType" group rounded tile>
                    <v-container fluid>
                        <v-btn value="cod" class="py-4 mr-2 ml-n2" outlined :style="themeInverted"
                            :block="isMobile ? true : false" :disabled="true">
                            <v-icon class="mr-2" :size="isMobile ? 12 : 24">mdi-cash</v-icon>
                            <label>Cash On Delivery</label>
                        </v-btn>
                        <!-- <v-btn value="credit-card" class="py-4 mr-2" outlined :style="themeInverted" :block="isMobile ? true : false">
                            <v-icon :size="isMobile ? 12 : 24"
                                class="mr-2">mdi-credit-card</v-icon>
                            <label>Credit Card</label>
                        </v-btn>
                        <v-btn value="upi" class="py-4 mr-2" outlined :style="themeInverted" :block="isMobile ? true : false">
                            <v-icon :size="isMobile ? 12 : 24" class="mr-2">mdi-google</v-icon>
                            <label>UPI</label>
                        </v-btn> -->
                    </v-container>
                </v-btn-toggle>
            </v-col>
            <v-col cols="12" sm="5">
                <cart-order-details :order="order" :type="2"></cart-order-details>
                <div class="py-4">
                    <span v-html="$store.getters.vendor.cancelPolicy"></span>
                    <br>
                    <app-dialog-with-btn title="Return Policy" label="Read Return Policy">
                        <template v-slot:activator="{ toggleDialog }">
                            <v-btn class="ml-2 black--text no-uppercase-btn text-decoration-underline" text href="#" @click="toggleDialog">Read Return
                                Policy</v-btn>
                        </template>
                        <span v-html="$store.getters.vendor.returnPolicy"></span>
                    </app-dialog-with-btn>
                </div>
            </v-col>
        </v-row>
    </v-container>
</template>

<script>
import moment from 'moment'
import AddressForm from '../../components/AddressForm.vue'
import AppDialogWithBtn from '../../components/AppDialogWithBtn.vue'
import CartOrderDetails from '../../components/CartOrderDetails.vue'
import Coupon from '../../components/Coupon.vue'
import CustomerDetailsForm from '../../components/CustomerDetailsForm.vue'
import ListAddresses from '../../components/ListAddresses.vue'
import appConstants from '../../utils/appConstants'
export default {
    components: { CartOrderDetails, ListAddresses, CustomerDetailsForm, AddressForm, Coupon, AppDialogWithBtn},
    data() {
        return {
            PICKUP_FROM_SHOP: 'pick-up-from-shop',
            HOME_DELIVERY: 'home-delivery',
            orderType: 'pick-up-from-shop',
            paymentType: 'cod',
            pickupPoints: this.$store.getters.vendor.pickupPoints,
            userAddresses: [],
            order: undefined,
        }
    },
    mounted () {
        this.order = this.$store.getters.order;
        this.order.vendorId = this.$store.getters.vendor._id
        this.order.delivery.type = this.$store.getters.vendor?.delivery?.[0]
        this.updateDeliveryOption()
    },
    methods: {
        async readUserAddresses() {
            let profileId = this.getUserProfile() ? this.getUserProfile()._id : this.order.customer._id
            if(profileId){
                await this.getItem(appConstants.WEBSTORE_CUSTOMER_ADDRESSES.replace('$id', profileId)).then(data => {
                    this.userAddresses = data[0].addresses
                })
            }
        },
        updateDeliveryOption(){
            if(this.order.delivery.type.code == this.HOME_DELIVERY){
                this.order.delivery.date = this.setDeliveryDate()
                this.readUserAddresses()
            }else{
                this.resetAddresses()
                this.order.delivery.date = moment().format('DD/MM/YYYY')
            }
        },
        resetAddresses(){
            this.order.delivery.address = undefined;
        }
    },
}
</script>

<style scoped>
</style>
